import { Status } from "@/types/Status"

export enum ContentType {
  TEXT = "text",
  MEDIA = "media",
  INLINE_CARD = "inlineCard",
  MENTION = "mention",
  HARD_BREAK = "hardBreak",
  HEADING = "heading",
  LIST_ITEM = "listItem",
}

export enum CommentContentType {
  PARAGRAPH = "paragraph",
  BULLET_LIST = "bulletList",
}

type AssigneeType = {
  accountId: string
  accountType: string
  active: boolean
  displayName: string
  emailAddress: string
  self: string
  timeZone: string
  avatarUrls: string[]
}

export type AttachmentType = {
  author: AssigneeType
  content: string
  created: string
  filename: string
  id: string
  mimeType: string
  self: string
  size: number
  thumbnail: string
}

export type AttrsType = {
  layout: string
  collection: string
  height: number
  id: string
  type: string
  width: number
  url: string
  text: string
}

type ContentListItem = {
  text: string
  type: string
  content: ContentListItem
  attrs: AttrsType
}

export type ContentInWithinInnerType = {
  text: string
  type: string
  content: ContentListItem[]
  attrs: AttrsType
}

export type ContentWithinInnerType = {
  text: string
  type: string
  content: ContentInWithinInnerType[]
  attrs: AttrsType
}

export type ContentInnerType = {
  type: string
  content: ContentWithinInnerType[]
  attrs: AttrsType
  text: string
}

type BodyType = {
  version: number
  type: string
  content: ContentInnerType[]
}

export type CommentType = {
  author: AssigneeType
  created: string
  id: string
  jsdPublic: boolean
  self: string
  updateAuthor: AssigneeType
  updated: string
  body: BodyType
}

type CommentsType = {
  maxResults: number
  self: string
  startAt: number
  total: number
  comments: CommentType[]
}

type StatusType = {
  description: string
  iconUrl: string
  id: string
  name: string
  self: string
  statusCategory: {
    colorName: string
  }
}

type PriorityType = {
  name: string
  iconUrl: string
}

type CustomFieldType = {
  value: string
}

type IssueLinkType = {
  id: string
  inward: string
  name: string
  outward: string
  self: string
}

export type FieldsType = {
  assignee: AssigneeType
  attachment: AttachmentType[]
  comment: CommentsType
  creator: AssigneeType
  description: BodyType
  reporter: AssigneeType
  status: StatusType
  updated: string
  summary: string
  priority: PriorityType
  created: string
  issuelinks: IssueLink[]
  customfield_10092: CustomFieldType
}

export interface IIssueLinkInward {
  id: string
  key: string
  self: string
  fields: FieldsType

  readonly status: Status
}

export type IssueLink = {
  id: string
  self: string
  type: IssueLinkType
  inwardIssue?: IIssueLinkInward
  outwardIssue?: IIssueLinkInward
}

export interface IJiraIssue {
  expand: string
  fields: FieldsType
  id: string
  key: string
  self: string

  readonly status: Status
}

export interface IOpenIssues {
  maxResults: number
  startAt: number
  total: number
  issues: IJiraIssue[]
}

export interface IOpenIssuesPayload {
  priority: number
}

export interface IJiraIssuesPayload {
  status: string | Array<string>
  system: string | Array<string>
}
